import { setLoadPanelVisible, setToastError } from "@/redux/shareSlice";
import { store } from "@/store/store";
import { Utilities } from "../utils/utilities";

export function dataLoading(defaultReturnValue: any) {
  return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
    const originalMethod = descriptor.value;

    descriptor.value = async function (...args: any[]) {
      try {
        store.dispatch(setLoadPanelVisible(true));
        return await originalMethod.apply(this, args);
      } catch (error: any) {
        // Utilities.fileDownload(JSON.stringify({ error, response: error.response }), "response.txt", "text/plain");
        console.log(error);
        var errorMsg =
          error && error.response && error.response.data && typeof error.response.data === "string" ? `error message:\r\n${error.response.data}` : "";
        store.dispatch(setToastError(`Error in calling backend service.\r\n\r\n${errorMsg}`));
        return defaultReturnValue;
      } finally {
        store.dispatch(setLoadPanelVisible(false));
      }
    };

    return descriptor;
  };
}

export function dataLoadingWithResponse400Return(target: any, propertyKey: string, descriptor: PropertyDescriptor) {
  const originalMethod = descriptor.value;
  descriptor.value = async function (...args: any[]) {
    try {
      store.dispatch(setLoadPanelVisible(true));
      return await originalMethod.apply(this, args);
    } catch (error: any) {
      if (error && error.response && error.response.status === 400) {
        return error.response;
      }

      // Utilities.fileDownload(JSON.stringify({ error, response: error.response }), "response.txt", "text/plain");
      console.log(error);
      var errorMsg =
        error && error.response && error.response.data && typeof error.response.data === "string" ? `error message:\r\n${error.response.data}` : "";
        store.dispatch(setToastError(`Error in calling backend service.\r\n\r\n${errorMsg}`));
      return undefined;
    } finally {
      store.dispatch(setLoadPanelVisible(false));
    }
  };

  return descriptor;
}
